import React, { useState, useEffect } from 'react';
import './CreatePlayer.css';
import { Link, useLocation , useSearchParams} from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
const CreatePlayer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('auth-token');
  const { selectedCenter, userData } = useUser();
  const loginId = userData.userId
  const [searchParams] = useSearchParams();
  const academyId = searchParams.get("academyId");
  const playerId = searchParams.get("playerId");
  const userId = searchParams.get("userId");
  const guardianId = searchParams.get("guardianId");
  
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    gender: '',
    playerCategory: '',
    playerLevel: '',
    playerProfile: '',
    dob: '',
    parentInfo: [
      { parentName: '', parentMobileNumber: '', parentRelation: '' },
      { parentName: '', parentMobileNumber: '', parentRelation: '' },
    ],
    hideProfileStats: false,
  });
  const [dropdownData, setDropdownData] = useState({
    genderTypes: [],
    playerCategoryTypes: [],
    playerLevelTypes: []
  });

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_NEW_PLAYER}?academyId=${selectedCenter}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const result = await response.json();
        if (result.success) {
          setDropdownData({
            genderTypes: result.data.genderTypes,
            playerCategoryTypes: result.data.playerCategoryTypes,
            playerLevelTypes: result.data.playerLevelTypes
          });
        }
      } catch (error) {

      }
    };

    if (selectedCenter) {
      fetchDropdownData();
    }
  }, [selectedCenter]);

  useEffect(() => {
    if (!playerId) return;

    const fetchPlayerData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_UPDATE_PLAYER}?academyId=${selectedCenter}&playerId=${playerId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const result = await response.json();

        if (result.success) {
          const playerData = result.data.playerForm;

          const formattedDOB = playerData.dateOfBirth
            ? playerData.dateOfBirth.split("T")[0]
            : '';
          const formattedJoiningDate = playerData.joiningDate
            ? playerData.joiningDate.split('T')[0]
            : null;
          setFormData({
            name: playerData.name || '',
            mobileNumber: playerData.mobileNumber ? playerData.mobileNumber.replace(/^\+91/, '') : '',
            gender: playerData.genderType || '',
            playerCategory: playerData.playerCategoryType || '',
            playerLevel: playerData.playerLevelType || 'NA',
            playerProfile: playerData.playerProfile || 'NA',
            dob: formattedDOB,
            joiningDate: formattedJoiningDate,
            parentInfo: playerData.playerParentForms
              ? playerData.playerParentForms.map(parent => ({
                parentId: parent.id || null,
                parentName: parent.name || '',
                parentMobileNumber: parent.mobileNumber?.replace(/^\+91/, '') || '',
                parentRelation: parent.relation || '',
              }))
              : [{ parentName: '', parentMobileNumber: '', parentRelation: '' }],
            hideProfileStats: playerData.isStatsHidden || false,
          });
        }
      } catch (error) {

      }
    };

    fetchPlayerData();
  }, [playerId]);
  useEffect(() => {
    if (!userId) return;

    const fetchPlayerData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_GET_PLAYER}/${userId}?LoginUser=${loginId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (result.success) {
          const playerData = result.data.player;

          let formattedDOB = '';
          if (playerData.dob) {
            const [day, month, year] = playerData.dob.split('-');
            formattedDOB = `${year}-${month}-${day}`;
          }

          setFormData({
            name: playerData.name || '',
            mobileNumber: (playerData.mobileNumber || '').replace(/^\+91/, ''),
            gender: playerData.gender || '',
            playerCategory: playerData.playerCategory || 'NA',
            playerLevel: playerData.playerLevel || 'NA',
            playerProfile: playerData.playerProfile || 'NA',
            dob: formattedDOB,
            parentInfo: playerData.parentDetails?.length > 0 ? [{
              parentName: playerData.parentDetails[0]?.name || '',
              parentMobileNumber: playerData.parentDetails[0]?.mobileNumber.replace(/^\+91/, '') || '',
              parentRelation: playerData.parentDetails[0]?.relation || '',
            }] : [],
            hideProfileStats: playerData.isStatsHidden || false,
          });
        }

      } catch (error) {

      }
    };

    fetchPlayerData();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name && name.startsWith('parentInfo')) {
      const matches = name.match(/parentInfo\[(\d+)\]\.(\w+)/);
      if (matches) {
        const index = parseInt(matches[1]);
        const field = matches[2];
        const updatedParentInfo = [...formData.parentInfo];
        updatedParentInfo[index][field] = value;
        setFormData({ ...formData, parentInfo: updatedParentInfo });
        return;
      }
    }

    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


    const isPlayerMobileValid = formData.mobileNumber && /^[0-9]{10}$/.test(formData.mobileNumber);

    const hasValidParentMobile = formData.parentInfo.some(
      (parent) => /^[0-9]{10}$/.test(parent.parentMobileNumber)
    );

    if (!isPlayerMobileValid && !hasValidParentMobile) {
      Swal.fire({
        icon: 'error',
        title: 'Mobile Number Required',
        text: 'Please enter either a valid 10-digit player mobile number or a parent mobile number.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const playerParentForms = formData.parentInfo
      .filter(parent =>

        parent.parentName ||
        parent.parentMobileNumber ||
        parent.parentRelation
      )
      .map(parent => ({
        id: parent.parentId || null,
        name: parent.parentName.trim(),
        mobileNumber: parent.parentMobileNumber ? `+91${parent.parentMobileNumber}` : null,
        relation: parent.parentRelation.trim()
      }));
    const joiningDate = playerId
      ? formData.joiningDate
      : new Date().toISOString().split('T')[0];

    const requestBody = {
      academyId: Number(selectedCenter),
      id: null || playerId,
      mobileNumber: formData.mobileNumber ? `+91${formData.mobileNumber}` : null,
      name: formData.name.trim(),
      playerCategoryType: formData.playerCategory.toUpperCase() || null,
      playerLevelType: formData.playerLevel.toUpperCase() ||null,
      playerProfile: formData.playerProfile.toUpperCase() || null ,
      dateOfBirth: formData.dob || null,
      joiningDate: joiningDate ,
      genderType: formData.gender.toUpperCase() || null ,
      playerParentForms: playerParentForms,
    };

    try {
      const response = await fetch(process.env.REACT_APP_API_NEW_PLAYER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (response.ok) {
        const message = playerId ? "Player updated successfully!" : "Player created successfully!";

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        navigate(-1);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: result.errorMessage || result.message || "Unknown error",
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: "An error occurred while creating the player.",
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };


  const [searchTerm, setSearchTerm] = useState('');
  const [Attendance, setAttendance] = useState([]);

  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_GET_PLAYER}/${userId}?LoginUser=${loginId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (result.success) {
          const batches = result.data.player.batches || [];

          const formattedData = batches.map((item, index) => ({
            id: item.batchId || index,
            batchName: item.batchName,
            academyName: item.academyName,
            playerName: item.name,
            playerId: item.playerId,
            batchId: item.batchId,
            status: item.status ? "Active" : "Inactive",
            primary: item.primary ? "True" : "False",
          }));


          setAttendance(formattedData);
        }
      } catch (error) {
      }
    };

    fetchAttendance();
  }, []);


  const headers = [
    { label: "Name", key: "batchName" },
    { label: "Academy", key: "academyName" },

    { label: "Batch", key: "month" },
    { label: "Primary", key: "year" },
    { label: "Removed", key: "attendance" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredAttendance = Attendance.filter((Attend) =>
    Object.values(Attend)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSort = (columnKey) => {
    let direction = 'asc';
    if (sortConfig.key === columnKey && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortedAttendance = [...filteredAttendance].sort((a, b) => {
    if (sortConfig.key === '') return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    if (sortConfig.direction === 'asc') {
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    } else {
      return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
    }
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedAttendance.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredAttendance.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const renderSortArrow = (columnKey) => {
    if (sortConfig.key !== columnKey) return null;
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  const totalEntries = filteredAttendance.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  const genderOptions = dropdownData.genderTypes.map(gender => ({
    value: gender,
    label: gender.charAt(0) + gender.slice(1).toLowerCase()
  }));

  const playerCategoryOptions = dropdownData.playerCategoryTypes.map(category => ({
    value: category,
    label: category
  }));

  const playerLevelOptions = dropdownData.playerLevelTypes.map(level => ({
    value: level,
    label: level.split('_').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join(' ')
  }));

  const playerProfileOptions = dropdownData.playerLevelTypes.map(level => ({
    value: level,
    label: level === 'NA' ? 'N/A' :
      level.split('_').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join(' ')
  }));
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

  const toggleDropdown = (playerKey, e) => {
    e.stopPropagation();
    if (dropdownOpen === playerKey) {
      return setDropdownOpen(null);
    }
    const { bottom, left } = e.currentTarget.getBoundingClientRect();
    setDropdownPos({
      top: bottom + window.scrollY,
      left: left + window.scrollX,
    });
    setDropdownOpen(playerKey);
  };

  useEffect(() => {
    const closeOnScroll = () => setDropdownOpen(null);

    window.addEventListener('scroll', closeOnScroll, true);
    return () => window.removeEventListener('scroll', closeOnScroll, true);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.custom-dropdown-player');
      if (dropdown && !dropdown.contains(event.target) && !event.target.closest('.dots-btn-player')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

const handleNavigate = (event, url) => {
  if (event.metaKey || event.ctrlKey) {
    window.open(url, "_blank");
  } else {
    navigate(url);
  }
};

const handleActionClick = (event, action, batchId, playerId) => {
  if (action === "Attendance") {
    handleNavigate(event, `/playerAttendance?batchId=${batchId}&playerId=${playerId}`);
  }
  else if (action === "Performance") {
    handleNavigate(event, `/performance?batchId=${batchId}&playerId=${playerId}`);
  }
  else if (action === "Update Payment") {
    handleNavigate(event, `/playerpaymentDetail?batchId=${batchId}&playerId=${playerId}`);
  }
};

  const handleDelete = async (batchId, playerId) => {

    const url = `${process.env.REACT_APP_API_DELETE_PLAYER}?playerId=${playerId}&batchId=${batchId}`;

    const headers = {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`,
    };

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: headers,
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Successfully removed",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        setAttendance(prev =>
          prev.map(att => {
            if (att.batchId === batchId && att.playerId === playerId) {
              return {
                ...att,
                primary: "False",
                status: "Inactive",
              };
            }
            return att;
          })
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to delete",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleSetPrimary = async (batchId, playerId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_MAKE_PRIMARY}?batch_id=${batchId}&player_id=${playerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Player has been set as primary.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to set primary player.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleEnable = (event, batchId, playerId) => {
    if (event?.metaKey || event?.ctrlKey) {
      window.open(`/addPlayerPayment?batchId=${batchId}&playerId=${playerId}`, "_blank");
    } else {
      navigate(`/addPlayerPayment?batchId=${batchId}&playerId=${playerId}`);
    }
  };
  
  
  useEffect(() => {
    const { dob, playerCategory } = formData;
    const categories = dropdownData.playerCategoryTypes;
    if (!dob || categories.length === 0) return;
    const today = new Date();
    const birth = new Date(dob);
    let age = today.getFullYear() - birth.getFullYear();
    const mDiff = today.getMonth() - birth.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    const desired = age + 1;

    let autoCat;
    if (desired > 17 && categories.includes('OPEN')) {
      autoCat = 'OPEN';
    } else {
      const nums = categories
        .filter(cat => /^U\d+$/.test(cat))
        .map(cat => parseInt(cat.slice(1), 10));

      const ge = nums.filter(n => n >= desired);
      const pickNum = ge.length ? Math.min(...ge) : Math.max(...nums);
      autoCat = `U${pickNum}`;
    }

    if (autoCat !== playerCategory) {
      setFormData(prev => ({ ...prev, playerCategory: autoCat }));
    }
  }, [formData.dob, formData.playerCategory, dropdownData.playerCategoryTypes]);

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/createNewPlayer" className="breadcrumb-link">Search User</Link> &gt; New Player
      </div>
      <form onSubmit={handleSubmit} className="walkin-enquiry-form">

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="text"
            id="name"
            name="name"
            className={`walkin-form ${formData.name ? 'has-value' : ''}`}
            value={formData.name}
            onChange={handleChange}
            required
            disabled={!!userId}
          />
          <label htmlFor="name">Player Name</label>
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="number"
            id="mobileNumber"
            name="mobileNumber"
            className={`walkin-form ${formData.mobileNumber ? 'has-value' : ''}`}
            value={formData.mobileNumber}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                handleChange(e);
              }
            }}
            disabled={!!userId}
            maxLength={10}
            placeholder="Enter Mobile Number"
          />
          {formData.mobileNumber && (
            <label htmlFor="mobileNumber">Mobile Number</label>
          )}
        </div>



        <div className="floating-select-form" style={{ width: '98%' }}>
          <Select
            id="gender"
            name="gender"
            className={`walkin-form-dropdown ${formData.gender ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={genderOptions}
            value={genderOptions.find(option => option.value === formData.gender)}
            onChange={selected => setFormData({ ...formData, gender: selected?.value || '' })}
            placeholder="Select Gender"
            isClearable
            isDisabled={!!userId}
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.gender && (
            <label htmlFor="gender">Gender</label>
          )}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <Select
            id="playerCategory"
            name="playerCategory"
            className={`walkin-form-dropdown ${formData.playerCategory ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={playerCategoryOptions}
            value={playerCategoryOptions.find(option => option.value === formData.playerCategory)}
            onChange={selected => setFormData({ ...formData, playerCategory: selected?.value || '' })}
            placeholder="Select Category"
            isClearable
            isDisabled={!!userId}
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.playerCategory && (
            <label htmlFor="playerCategory">Player Category</label>
          )}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <Select
            id="playerLevel"
            name="playerLevel"
            className={`walkin-form-dropdown ${formData.playerLevel ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={playerLevelOptions}
            value={playerLevelOptions.find(option => option.value === formData.playerLevel)}
            onChange={selected => setFormData({ ...formData, playerLevel: selected?.value || '' })}
            placeholder="Select Level"
            isClearable
            isDisabled={!!userId}
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.playerLevel && (
            <label htmlFor="playerLevel">Player Level</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <Select
            id="playerProfile"
            name="playerProfile"
            className={`walkin-form-dropdown ${formData.playerProfile ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={playerProfileOptions}
            value={playerProfileOptions.find(option => option.value === formData.playerProfile)}
            onChange={selected => setFormData({ ...formData, playerProfile: selected?.value || '' })}
            placeholder="Select Profile"
    
            isClearable
            isDisabled={!!userId}
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
        
          />
          {formData.playerProfile && (
            <label htmlFor="playerProfile">Player Profile</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="date"
            id="dob"
            name="dob"
            className={'walkin-form has-value'}
            value={formData.dob}
            onChange={handleChange}
            disabled={!!userId}
            onClick={e => e.target.showPicker()}
          />

          <label htmlFor="dob">Date of Birth</label>

        </div>


        <div className="input-container-hide-profile-stats">
          <input
            type="checkbox"
            id="hideProfileStats"
            name="hideProfileStats"
            checked={formData.hideProfileStats}
            onChange={handleChange}
            className="checkbox-field"
            disabled={!!userId}
          />
          <label htmlFor="hideProfileStats" className="checkbox-label">Hide Profile Stats</label>
        </div>

        <div>
          <h3 className="parent-info-title">Parent Information</h3>
          <table className="parent-info-table">
            <thead>
              <tr>
                <th>Parent Name</th>
                <th>Parent Mobile Number</th>
                <th>Relation</th>
              </tr>
            </thead>
            <tbody>
              {formData.parentInfo.map((parent, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      name={`parentInfo[${index}].parentName`}
                      value={parent.parentName}
                      onChange={handleChange}
                      className="input-field"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`parentInfo[${index}].parentMobileNumber`}
                      value={parent.parentMobileNumber}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/\D/g, '');
                        const updatedParentInfo = [...formData.parentInfo];
                        updatedParentInfo[index].parentMobileNumber = numericValue;
                        setFormData({ ...formData, parentInfo: updatedParentInfo });
                      }}
                      className="input-field"
                      maxLength={10}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`parentInfo[${index}].parentRelation`}
                      value={parent.parentRelation}
                      onChange={handleChange}
                      className="input-field"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>



        {((!playerId && !userId) || !playerId) && currentRows.length > 0 && (
          <div style={{padding:'10px',background:'#fff',borderRadius:'8px',marginTop:'10px'}}>
            <h3 className="parent-info-title">Player Batches</h3>

            <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
              <option value={10}>10 items per page</option>
              <option value={50}>50 items per page</option>
              <option value={75}>75 items per page</option>
              <option value={100}>100 items per page</option>
            </select>
            <div style={{ overflow: 'scroll' }}>
              <table className="challenges-table">
                <thead>
                  <tr className="challenges-header-row">
                    {headers.map((header) => (
                      <th
                        key={header.key}
                        className="challenges-column"
                        onClick={() => handleSort(header.key)}
                      >
                        {header.label} {renderSortArrow(header.key)}
                      </th>
                    ))}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((Attend) => (
                    <tr key={Attend.id} className="challenges-row">
                      <td className="challenges-cell">{Attend.playerName}</td>
                      <td className="challenges-cell">{Attend.academyName}</td>
                      <td className="challenges-cell">{Attend.batchName}</td>
                      <td className="challenges-cell">{Attend.primary}</td>
                      <td className="challenges-cell">{Attend.status}</td>
                      <td className="sport-actions-column">
                        <button
                          className="dots-btn-player"
                          type="button"
                          onClick={(e) => toggleDropdown(Attend.id, e)}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '24px',
                          }}
                        >
                          &#x22EE;
                        </button>

                        {dropdownOpen === Attend.id && (
                          <div
                            className="custom-dropdown-player"
                            style={{
                              position: 'absolute',
                              top: dropdownPos.top,
                              left: dropdownPos.left,
                              zIndex: 9999,
                              backgroundColor: 'white',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                              minWidth: '200px',
                            }}
                          >
                            <button
                              type="button"
                              className="dropdown-item"
                              onClick={(e) => handleActionClick(e, "Attendance", Attend.batchId, Attend.playerId)}
                            >
                              Attendance
                            </button>
                            <button
                              type="button"
                              className="dropdown-item"
                              onClick={(e) => handleActionClick(e, "Performance", Attend.batchId, Attend.playerId)}
                            >
                              Performance
                            </button>
                            <button
                              type="button"
                              className="dropdown-item"
                              onClick={(e) => handleActionClick(e, "Update Payment", Attend.batchId, Attend.playerId)}
                            >
                              Update Player Payment Details
                            </button>

                            {Attend.status === 'Inactive' ? (
                              <button
                                type="button"
                                className="dropdown-item"
                                onClick={(e) => handleEnable(e, Attend.batchId, Attend.playerId)}
                              >
                                Enable
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleDelete(Attend.batchId, Attend.playerId)}
                              >
                                Remove
                              </button>
                            )}

                            {Attend.primary === 'False' && (
                              <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleSetPrimary(Attend.batchId, Attend.playerId)}
                              >
                                Make this batch as Primary
                              </button>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="pagination">
              <div className="showing-entries">
                Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
              </div>
              <button
                className="prev-button"
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              {renderPagination()}
              <button
                className="next-button"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {!userId && (
          <button type="submit" className="submit-button">Submit</button>
        )}
        {guardianId && userId && (
          <button type="submit" className="submit-button">Submit</button>
        )}

      </form>
    </div>
  );
};

export default CreatePlayer;